import React from 'react';
import Translate from '~/components/Translate/Translate';

/**
 * Generates a validation message for minimum or maximum character length requirements.
 * @param {Object} params - The parameters object.
 * @param {number} params.limit - The character length limit.
 * @param {'min'|'max'} [params.type='min'] - The type of validation: 'min' or 'max'.
 * @param {string} [params.name=''] - The field name to include in the message.
 * @return {JSX.Element} A Translate component with the formatted validation message.
 * @author KJ
 */
export const getLengthMessage = ({ limit, type = 'min', name = '' }) => {
    const comparison = type === 'min' ? 'less' : 'more';
    const fieldPart = name ? ` for {name}` : '';
    const message = `Number of characters${fieldPart} cannot be ${comparison} than {limit}`;

    return (
        <Translate
            message={message}
            values={name ? { limit, name } : { limit }}
        />
    );
};
